import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

class TeamsThirdStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  render() {
    const { className } = this.props

    return (
      <div className={className}>
        <img
          src="/static/webapp/images/settings/teams-third-step.png"
          style={{ width: '563px', height: '370px' }}
        />
        <div className="actions-container">
          <div className="mt">
            <div className="number-indication">1</div>
            <span className="text-indication">
              Select the
              <b> Microsoft Teams Team </b>
              and the teams'
              <b> Microsoft Teams Channel </b>
              that will receive the push notifications from IRONSCALES, and click
              <b> Add workflow. </b>
              The
              <b> Workflow added successfully! </b>
              screen is displayed.
            </span>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="teams-backButton"
          />
          <Button
            text="Next Step"
            onClick={() => this.handleStepRedirect(1)}
            className="sml"
            id="teams-nextButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(TeamsThirdStep)`
  .download-icon {
    padding: 0;
    .is-button-internal-container {
      width: 160px;
      padding: 0;
    }
    img {
      margin-right: 5px;
    }
  }
  .buttons-container {
    margin-top: 62px;
  }
`
